// ============================================================
//  Skeleton — the one reusable loading primitive for the SPA.
//
//  <Skeleton> renders a single theme-aware shimmer rectangle; compose
//  several to mimic a screen's real layout (a row, a card, a page). The
//  shimmer gradient, colours and prefers-reduced-motion handling all live
//  in styles.css under the `.skel` block, which is shared with the older
//  hand-rolled dash-skel / wd-skel markup so every loading state in the app
//  shimmers identically and in the active theme's palette.
//
//  Props (all optional):
//    w / h      width / height — number → px, string → used verbatim
//    radius     border-radius — number → px, string verbatim
//    circle     true → a round dot (avatars, icon slots)
//    className  extra classes; style / other DOM props pass through
//
//  Skeletons are decorative, so every block is aria-hidden — screen readers
//  hear nothing until the real content (or an empty/error state) arrives.
// ============================================================

const px = (v) => (typeof v === 'number' ? `${v}px` : v);

export default function Skeleton({ w, h, radius, circle = false, className = '', style, ...rest }) {
  const s = { ...style };
  if (w != null) s.width = px(w);
  if (h != null) s.height = px(h);
  if (radius != null) s.borderRadius = px(radius);
  const cls = `skel${circle ? ' skel-circle' : ''}${className ? ` ${className}` : ''}`;
  return <div aria-hidden="true" className={cls} style={s} {...rest} />;
}

// ── SkeletonPage ──────────────────────────────────────────────
// The full-screen fallback shown while a route chunk is in flight (App.jsx
// Suspense) or while Firebase restores the session (ProtectedRoute). It is
// deliberately GENERIC — one fallback covers every route — but layout-shaped
// (a title bar over a stack of card blocks) so a page-load reads as "content
// arriving", never a blank screen with the word "Loading".
export function SkeletonPage() {
  return (
    <div className="skel-page" role="status" aria-label="Loading">
      <div className="skel-page-inner">
        <Skeleton className="skel-line" w="45%" h={26} radius={8} />
        <Skeleton w="100%" h={92} radius={16} style={{ marginTop: 8 }} />
        <Skeleton w="70%" h={14} radius={7} style={{ marginTop: 20 }} />
        <Skeleton w="100%" h={72} radius={16} style={{ marginTop: 4 }} />
        <Skeleton w="100%" h={72} radius={16} />
        <Skeleton w="100%" h={72} radius={16} />
      </div>
    </div>
  );
}
